import React, { useEffect, useState } from 'react';
import { voyagerTrack } from '@shared/voyager';
import OpenLaunchApp from './OpenLaunchApp';

export interface OpenAppEleProps {
  style?: React.CSSProperties;
  // 打点业务
  contentType: string;
  // 埋点参数
  pingParams?: any;
  // 微信开放标签里需要跳转的脉脉scheme url
  wxSchemeUrl?: string;
  // 不用微信开放标签跳转时的打开App回调，一般用该回调来进行打开show_open 页面
  jumpOpenApp?: () => void;
  // 是否写入剪贴板做归因分析，默认true
  writeClipboard?: boolean;
  // 需要写入剪贴板的归因key，key 由业务定义
  // 就是归因key的from，见文档：https://maimai.feishu.cn/wiki/wikcnAGt5e4Ss8m6lzZ38YRIcPX
  clipboardKey?: string;
  text?: string;
  height?: string;
  showConfirm?: boolean;
}

const useShowLaunchApp = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const isBrowserWindow = typeof window !== 'undefined' && globalThis === window;
    setShow(isBrowserWindow && !window.MaiMai_Native);
  }, [globalThis]);

  return show;
};

const OpenAppFromTop: React.FC<OpenAppEleProps> = (props) => {
  const {
    style,
    contentType,
    pingParams,
    wxSchemeUrl,
    jumpOpenApp,
    writeClipboard,
    clipboardKey,
    showConfirm = true,
  } = props;

  const show = useShowLaunchApp();

  const handleClick = () => {
    voyagerTrack('outside_content_page.all.all.click', {
      button_name: 'top_open_app',
      content_type: contentType,
      ...pingParams,
    });
  };

  const handleConfirm = () => {
    voyagerTrack('outside_content_page.all.all.click', {
      button_name: 'top_open_app_confirm',
      content_type: contentType,
      ...pingParams,
    });
  };

  return (
    <>
      {show && (
        <div
          style={{
            ...(styles.contentDownlode as React.CSSProperties),
            ...style,
          }}
        >
          <img style={styles.icon} src='https://i9.taou.com/maimai/p/32623/1127_6_315Y1XRpE51HVsF0' alt='' />
          <div style={styles.downLoadCenter}>
            <div style={styles.centerTitle}>脉脉</div>
            <div style={styles.centerDesc}>公司内部消息、大厂内推、薪资揭秘</div>
          </div>
          <OpenLaunchApp
            wxSchemeUrl={wxSchemeUrl}
            onClick={handleClick}
            jumpOpenApp={jumpOpenApp}
            writeClipboard={writeClipboard}
            clipboardKey={clipboardKey}
            showConfirm={showConfirm}
            onConfirm={handleConfirm}
          >
            <div style={styles.btn}>打开App</div>
          </OpenLaunchApp>
        </div>
      )}
    </>
  );
};

const OpenAppFromBottom: React.FC<OpenAppEleProps> = (props) => {
  const show = useShowLaunchApp();

  const handleClick = () => {
    voyagerTrack('outside_content_page.all.all.click', {
      button_name: 'bottom_open_app',
      content_type: props.contentType,
      ...props.pingParams,
    });
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: '50px',
            zIndex: 20,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            ...props.style,
          }}
        >
          <OpenLaunchApp
            wxSchemeUrl={props.wxSchemeUrl}
            onClick={handleClick}
            jumpOpenApp={props.jumpOpenApp}
            writeClipboard={props.writeClipboard}
            clipboardKey={props.clipboardKey}
          >
            <div style={styles.bottomBtn}>脉脉App内打开</div>
          </OpenLaunchApp>
        </div>
      )}
    </>
  );
};

const OpenAppFromContent: React.FC<OpenAppEleProps> = (props) => {
  const show = useShowLaunchApp();

  const handleClick = () => {
    voyagerTrack('outside_content_page.all.all.click', {
      button_name: 'open_app_better',
      content_type: props.contentType,
      ...props.pingParams,
    });
  };

  return (
    <>
      {show && (
        <OpenLaunchApp
          wxSchemeUrl={props.wxSchemeUrl}
          onClick={handleClick}
          jumpOpenApp={props.jumpOpenApp}
          writeClipboard={props.writeClipboard}
          clipboardKey={props.clipboardKey}
          height={props.height}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              ...props.style,
            }}
          >
            <span
              style={{
                color: '#6E727A',
                fontSize: '13px',
                fontWeight: 'bold',
              }}
            >
              {props.text || '打开App体验更好'}
            </span>
            <img
              style={{
                height: '12px',
                width: '12px',
                marginLeft: '3px',
              }}
              src='https://i9.taou.com/maimai/p/32625/3684_6_TpAajHy3LpDW'
              alt=''
            />
          </div>
        </OpenLaunchApp>
      )}
    </>
  );
};

export { OpenAppFromTop, OpenAppFromBottom, OpenAppFromContent };

const styles = {
  contentDownlode: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    height: '56px',
    background: '#ffffff',
    boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    padding: '0 12px',
    alignItems: 'center',
    zIndex: 20,
  },
  icon: {
    width: '36px',
    height: '36px',
  },
  downLoadCenter: {
    flex: 1,
    margin: '0 6px',
  },
  centerTitle: {
    fontSize: '17px',
    fontWeight: 500,
    color: '#15161F',
    lineHeight: 1,
    marginBottom: '5px',
  },
  centerDesc: {
    fontSize: '13px',
    color: '#6E727A',
    lineHeight: 1,
  },
  btn: {
    width: '80px',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '40px',
    background: '#0052FF',
    color: '#fff',
    fontSize: '13px',
    fontWeight: 500,
  },

  bottomBtn: {
    height: '44px',
    width: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '22px',
    background: '#1963FF',
    fontSize: '14px',
    color: '#fff',
    fontWeight: 500,
    boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.1)',
  },
};
